import cSpinner from '#themes/default/default/components/spinner/spinner.js';

import template from './paymentIframeModal.html' with { type: 'html' };

export default {
	name: 'CPaymentIframeModal',
	components: {
		cSpinner
	},
	data() {
		return {
			providerIframeLoaded: false,
			checkoutIframeSrc: this.getLink('payment-gateway-iframe', null)
		};
	},
	computed: {
		paymentGatewayProviderUrl() {
			return this.$store.state.paymentGatewayProviderUrl;
		}
	},
	mounted() {
		// Wait for the payment iframe to load the provider url and then hide the spinner
		window.addEventListener('message', (event) => {
			if (event.data.type === 'checkout-payment_provider-iframe-loaded') {
				this.providerIframeLoaded = true;
			}
		});
	},
	methods: {
		// Wait for the checkout payment iframe to be loaded and send the actual provider url to be loaded inside
		handleCheckoutIframeLoadEvent() {
			this.$refs.checkoutIframe.contentWindow.postMessage({
				type: 'checkout-payment_provider-iframe-src',
				payload: this.paymentGatewayProviderUrl
			});
		}
	},
	template
};
